import { gql } from 'graphql-request'

export namespace TicketCommentMutations {
  export function createTicketComment() {
    return gql`
      mutation createTicketComment($comment: TicketCommentMutation!, $attachments: [Upload!]) {
        createTicketComment(ticketComment: $comment, attachments: $attachments) {
          id
        }
      }
    `
  }
}
